import { FormControl, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { CustomObservabilityToolOptions } from 'components/status-checks/form/authentication/CustomObservabilityToolOptions'
import { ObservabilityToolAuthenticationTypeToggle } from 'components/status-checks/form/authentication/ObservabilityToolAuthenticationTypeToggle'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'

export const ObservabilityToolCustomAuthenticationDetails = () => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const { isEdit } = useObservabilityToolAuthenticationContext()
  const isPrivateNetworkIntegration = useWatch<StatusCheckFormValues>({
    control,
    name: 'isPrivateNetworkIntegration'
  })

  return (
    <>
      <CustomObservabilityToolOptions />
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography variant="h6">Authentication</Typography>
        <FormControl>
          <Typography sx={{ mb: 2 }}>
            What URL should Gremlin use to authenticate this observability tool?
          </Typography>
          <Controller
            control={control}
            name="authenticationUrl"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                data-testid="custom-observability-tool-authentication-url-input"
                disabled={isEdit}
                error={Boolean(error)}
                helperText={error?.message}
                label="Authentication Endpoint"
                variant="outlined"
              />
            )}
          />
        </FormControl>
        <Stack spacing={2} sx={{ mt: 4 }}>
          {isPrivateNetworkIntegration ? (
            <>
              <Typography>
                Which method would you like to authenticate your observability
                tool with?
              </Typography>
              <ObservabilityToolAuthenticationTypeToggle />
            </>
          ) : (
            <>
              <Typography>
                What value should Gremlin use for the Authorization header of
                this observability tool?
              </Typography>
              <ObservabilityToolHeaders isCustomObservabilityTool />
            </>
          )}
        </Stack>
      </Stack>
    </>
  )
}
